import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Article from './pages/Article';
import Search from './pages/Search';
import Timeline from './pages/Timeline';
import Maps from './pages/Maps';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/*" element={
          <div className="relative flex size-full min-h-screen flex-col overflow-x-hidden bg-[var(--background-color)] text-[var(--text-primary)]">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/article/:slug" element={<Article />} />
                <Route path="/search" element={<Search />} />
                <Route path="/category/:category" element={<Search />} />
                <Route path="/period/:period" element={<Search />} />
                <Route path="/timeline" element={<Timeline />} />
                <Route path="/maps" element={<Maps />} />
              </Routes>
            </main>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
